(function($) {
  if ($("html").hasClass("ua-ie")) {
    $(
      ".mn-refresh .resource-three-grid .resource-grid .col-wrap .card-wrap .img-wrap"
    ).imageResponsiveTopIe();
  }
})(jQuery);
